import PropTypes from 'prop-types';

import React from 'react';

function Link(props) {
  const { url } = props.entityKey
    ? props.contentState.getEntity(props.entityKey).getData()
    : '';

  return (
    <a
      href={url}
      style={{ cursor: 'pointer' }}
      onClick={props.onClick}
    >
      {props.children}
    </a>
  );
}

Link.propTypes = {
  contentState: PropTypes.object,
  entityKey: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default Link;
